export let insetObject = {
	orderId: "",
	customerName: "",
	orderStatus: "",
	orderSource: "",
	createdDate: ""
}

export let storageCardTypes = [{
		id: 1,
		name: "Plošný materiál"
	},
	{
		id: 2,
		name: "Hranovací materiál"
	}
]

export let tableHeader = [{
		text: "Id",
		value: "id",
		align: "left"
	},
	{
		text: "Názov",
		value: "name",
		align: "left"
	},
	{
		text: "Mrp karta",
		value: "foreignCard",
		align: "right"
	},
	{
		text: "Produkt kód",
		value: "productCode",
		align: "left"
	},
	{
		text: "Nákupná cena",
		value: "price0",
		align: "left"
	},
	{
		text: "Cena 1",
		value: "price1",
		align: "left"
	},
	{
		text: "Počet vzhliadnutí",
		value: "rating",
		align: "left"
	},
	{
		text: "Typ skladovej karty",
		value: "storageCardTypeDescription",
		align: "left"
	},
	{
		text: "Aktívna",
		value: "active",
		align: "left"
	},
	{
		text: "",
		value: "action",
		sortable: false
	}
]